import { Notify, Dialog, Toast } from 'vant'

function warn(msg) {
  Notify({ type: 'warning', message: msg })
}

function alert(msg, opt = {}) {
  opt.allowHtml = true
  return Dialog.alert(Object.assign({
    title: '提示',
    message: msg
  }, opt))
}

function success(msg) {
  return new Promise((resolve, reject) => {
    Toast.success(Object.assign({
      type: 'success',
      message: msg,
      onClose: () => {
        resolve()
      }
    }))
  })
}

function fail(msg) {
  return Toast.fail(msg)
}

function error(msg, opt = {}) {
  opt.allowHtml = true
  return Dialog.alert(Object.assign({
    title: '错误',
    message: msg
  }, opt))
}

export default {
  warn,
  alert,
  success,
  fail,
  error
}
